import {
  uploadFile as apiUploadFile,
  getMeetingFiles as apiGetMeetingFiles,
  getFileDataUrl as apiGetFileDataUrl,
  deleteFile as apiDeleteFile,
} from "./api";

/**
 * Re-export file-related functions from the main API file
 */
export const uploadFile = apiUploadFile;
export const getMeetingFiles = apiGetMeetingFiles;
export const getFileDataUrl = apiGetFileDataUrl;
export const deleteFile = apiDeleteFile;
